import React, { useState, useEffect } from "react";
import Messages from "./components/Messages/Messages";
import Input from "./components/Input/Input";
import "./App.css";
import { drone, room } from "./utils/Scaledrone";

const App = () => {
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    room.on("message", (message) => {
      setMessages((prevMessages) => [...prevMessages, message]);
    });
  }, []);

  return (
    <div className="App">
      <div className="App-header">
        <h1>My Chat App</h1>
      </div>
      <Messages messages={messages} drone={drone} />
      <Input drone={drone} />
    </div>
  );
};

export default App;
